import React, { Dispatch } from 'react';

import { ButtonGroup } from '../../../../ui-kit';

interface ToggleChartTableBtnGroupProps {
  isChart: boolean;
  setIsChart: Dispatch<React.SetStateAction<boolean>>;
}
export const ToggleChartTableBtnGroup = ({
  isChart,
  setIsChart,
}: ToggleChartTableBtnGroupProps) => (
  <ButtonGroup
    groupClassName="w-[160px]"
    buttons={[
      {
        label: 'Chart',
        value: true,
      },
      {
        label: 'Table',
        value: false,
      },
    ]}
    checkedValue={isChart}
    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
      const { value } = e.target as HTMLButtonElement;
      let parsedValue: string | number | boolean = value;
      if (value === 'true') parsedValue = true;
      else if (value === 'false') parsedValue = false;
      setIsChart(parsedValue as unknown as boolean);
    }}
  />
);
